/** Given a hotel, returns true if it's "in the near", otherwise false. */
export const inTheNear = ({ distance }) => distance !== -1;
